<template>
  <v-layout
    align-center
    wrap
  >
    <v-flex
      v-for="(item, index) in representatives"
      :key="item.id"
      xs12
      :class="[{ 'personal-form': item.complete }]"
    >
      <v-layout>
        <v-flex
          class="mt-4 mr-2"
          :shrink="lgAndUp"
        >
          <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
        </v-flex>
        <v-flex>
          <v-layout :wrap="$vuetify.breakpoint.mdAndDown">
            <v-flex
              v-if="getFamilyGuideQuestions.representatives.hasOwnProperty('first_name')"
              md3
              lg12
            >
              <v-text-field
                v-model.trim="item.representativeData.firstName"
                v-validate="validationRules.get('first_name')"
                :error-messages="errors.collect(createDataName('first_name', item.id))"
                :label="getFamilyGuideQuestions.representatives.first_name.label"
                :data-vv-as="$t('label.first_name')"
                :data-vv-name="createDataName('first_name', item.id)"
                :required="getFamilyGuideQuestions.representatives.first_name.required"
                class="ml-1"
                :class="{ 'ml-2': lgAndUp }"
                :disabled="readOnly"
                @blur="completePersonData(item.id)"
                @focus="item.complete = false"
              />
            </v-flex>
            <v-flex
              v-if="getFamilyGuideQuestions.representatives.hasOwnProperty('last_name')"
              md4
              lg12
            >
              <v-text-field
                v-model.trim="item.representativeData.lastName"
                v-validate="validationRules.get('last_name')"
                :error-messages="errors.collect(createDataName('last_name', item.id))"
                :label="getFamilyGuideQuestions.representatives.last_name.label"
                :data-vv-as="$t('label.last_name')"
                :data-vv-name="createDataName('last_name', item.id)"
                :required="getFamilyGuideQuestions.representatives.last_name.required"
                class="ml-1"
                :class="{ 'ml-2': lgAndUp }"
                :disabled="readOnly"
                @blur="completePersonData(item.id)"
                @focus="item.complete = false"
              />
            </v-flex>
            <v-flex
              md4
              lg12
            >
              <v-layout
                class="ml-1"
                :class="{ 'ml-2': lgAndUp }"
              >
                <v-flex
                  v-if="getFamilyGuideQuestions.representatives.hasOwnProperty('age')"
                  xs8
                  sm6
                  shrink
                >
                  <v-text-field
                    v-model.number="item.representativeData.age"
                    v-validate="{ ...ageRules }"
                    :label="getFamilyGuideQuestions.representatives.age.label"
                    :error-messages="errors.collect(createDataName('age', item.id))"
                    :data-vv-as="$t('label.age')"
                    :data-vv-name="createDataName('age', item.id)"
                    :required="getFamilyGuideQuestions.representatives.age.required"
                    :disabled="readOnly"
                    inputmode="numeric"
                    @blur="completePersonData(item.id)"
                    @focus="item.complete = false"
                  />
                </v-flex>
                <v-flex
                  v-if="getFamilyGuideQuestions.representatives.hasOwnProperty('age_option')"
                  xs4
                  sm7
                >
                  <v-select
                    v-model="item.representativeData.ageOption"
                    append-icon="keyboard_arrow_down"
                    :items="age"
                    class="small-select"
                    item-text="description"
                    item-value="id"
                    :disabled="readOnly"
                    @blur="completePersonData(item.id)"
                    @focus="item.complete = false"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="getFamilyGuideQuestions.representatives.hasOwnProperty('education')"
              md4
              lg12
            >
              <v-autocomplete
                v-model="item.representativeData.education"
                v-validate="{
                  required: getFamilyGuideQuestions.representatives.education.required
                }"
                :error-messages="errors.collect(createDataName('education', item.id))"
                :label="getFamilyGuideQuestions.representatives.education.label"
                :data-vv-as="$t('label.education')"
                :data-vv-name="createDataName('education', item.id)"
                :required="getFamilyGuideQuestions.representatives.education.required"
                append-icon="keyboard_arrow_down"
                class="ml-1"
                :class="{ 'ml-2': lgAndUp }"
                :items="education"
                item-value="id"
                item-text="description"
                :disabled="readOnly"
                @blur="completePersonData(item.id)"
                @focus="item.complete = false"
              />
            </v-flex>
            <v-flex
              v-if="getFamilyGuideQuestions.representatives.hasOwnProperty('relation')"
              md4
              lg12
            >
              <v-autocomplete
                v-model="item.representativeData.relation"
                v-validate="{ required: getFamilyGuideQuestions.representatives.relation.required }"
                :error-messages="errors.collect(createDataName('relation', item.id))"
                :label="getFamilyGuideQuestions.representatives.relation.label"
                :data-vv-as="$t('label.relation')"
                :data-vv-name="createDataName('relation', item.id)"
                :required="getFamilyGuideQuestions.representatives.relation.required"
                append-icon="keyboard_arrow_down"
                class="ml-1"
                :class="{ 'ml-2': lgAndUp }"
                :items="relations(index)"
                item-value="id"
                item-text="description"
                :disabled="readOnly"
                @blur="completePersonData(item.id)"
                @focus="item.complete = false"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout
            align-center
            class="mt-3"
          >
            <v-flex :mx-3="index === 0">
              <a
                v-if="index !== 0"
                :class="{ disabled: !isCurrentEdition || readOnly }"
                @click="initRemovePerson(item.id)"
              >
                <BaseIcon class="clickable ml-2 mt-1">
                  <CartIcon :icon-color="$vuetify.theme.sz_grey" />
                </BaseIcon>
              </a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider class="mt-3 mb-2" />
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <a
        class="link_iconed mt-1"
        :class="{ disabled: !isCurrentEdition || readOnly }"
        @click="addPerson"
      >
        <v-icon>add</v-icon> {{ $t('buttons.add_person') }}</a>
    </v-flex>
    <v-text-field
      v-model="newAmount"
      v-validate="'required'"
      disabled
      class="d-none"
      solo
      data-vv-name="familyLength"
    />
    <ConfirmDialog
      :title="$t('sheet.sheetOne.meeting.family_guide.confirm_dialog')"
      :visible="removeDialog"
      @dialog="removeDialog = $event"
      @response-ok="removePerson()"
    />
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';
import CartIcon from '@/icons/CartIcon';
import BaseIcon from '@/icons/BaseIcon';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';

import debounce from 'lodash.debounce';
import ConfirmDialog from '@/components/widgets/ConfirmDialog';
import { mapGetters } from 'vuex';

import has from 'lodash.has';

export default {
    name: 'FamilyRepresentativeForm',
    components: {
        ConfirmDialog,
        CartIcon,
        BaseIcon
    },
    mixins: [sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        value: {},
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            representatives: [
                {
                    id: 0,
                    representativeData: {
                        id: 0,
                        firstName: '',
                        lastName: '',
                        age: null,
                        ageOption: 1,
                        education: null,
                        relation: null
                    },
                    complete: false
                }
            ],
            removeDialog: false,
            removeActiveId: null,
            initAmount: 0,
            newAmount: 0
        };
    },
    computed: {
        ...mapGetters('sheet', ['getFamilyGuideQuestions']),
        lgAndUp () {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        age () {
            return this.getResources(this.getFamilyGuideQuestions.representatives.age_option);
        },
        education () {
            return this.getResources(this.getFamilyGuideQuestions.representatives.education);
        },
        roleFemale () {
            return this.getResources(this.getFamilyGuideQuestions.representatives.relation);
        },
        roleMale () {
            return this.getResources(this.getFamilyGuideQuestions.representatives.relation, 1);
        },
        roles () {
            return has(this.getFamilyGuideQuestions?.representatives?.relation, 'resources')
                ? this.roleFemale
                : this.roleFemale.concat(this.roleMale);
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        ageRules () {
            return {
                required: this.getFamilyGuideQuestions.representatives.age.required,
                ...validationRules.get('age')
            };
        }
    },
    watch: {
        representatives: {
            handler: debounce(
                function (after, before) {
                    const data = [];
                    after.forEach((el) => {
                        data.push(el.representativeData);
                    });
                    this.$emit('input', data);
                },
                1000,
                { leading: true }
            ),
            deep: true
        },
        removeDialog (val) {
            if (val === false) {
                this.removeActiveId = null;
            }
        },
        newAmount (val) {
            this.$set(this.fields.familyLength, 'changed', val !== this.initAmount);
            this.$set(this.fields.familyLength, 'touched', true);
        }
    },
    created () {
        if (this.value != null && this.value.length > 0) {
            this.representatives = [];
            this.value.forEach((el, index) => {
                const _complete = this.checkIfDataComplete(el);
                this.representatives.push({ id: index, representativeData: el, complete: _complete });
            });
        }
        this.initAmount = this.representatives.length;
        this.newAmount = this.initAmount;
    },
    methods: {
        addPerson () {
            if (this.readOnly) {
                return;
            }
            const _id = Date.now();
            const _obj = {
                id: _id,
                representativeData: {
                    id: _id,
                    firstName: '',
                    lastName: '',
                    age: null,
                    ageOption: 1,
                    education: null,
                    relation: null
                },
                complete: false
            };
            this.representatives.push(_obj);
            this.newAmount = this.representatives.length;
        },
        initRemovePerson (id) {
            if (!this.isCurrentEdition || this.readOnly) {
                return;
            }
            this.removeActiveId = id;
            this.removeDialog = true;
        },
        removePerson () {
            if (this.readOnly) {
                return;
            }
            this.$store.commit('sheet/setRemoveRepresentative', true);
            if (this.representatives.length > 1) {
                this.representatives.forEach((el, index) => {
                    if (el.id === this.removeActiveId) {
                        this.representatives.splice(index, 1);
                    }
                });
            } else {
                this.representatives[0].id = 0;
                this.representatives[0].representativeData.firstName = '';
                this.representatives[0].representativeData.lastName = '';
                this.representatives[0].representativeData.age = null;
                this.representatives[0].representativeData.education = null;
                this.representatives[0].representativeData.relation = null;
                this.representatives[0].complete = false;
            }
            this.removeDialog = false;
            this.newAmount = this.representatives.length;
        },
        createDataName (name, id) {
            return name + id;
        },
        completePersonData (id) {
            this.representatives.forEach((el) => {
                if (el.id === id) {
                    const _keys = [];
                    Object.keys(this.fields).forEach((key) => {
                        if (key.indexOf(id) !== -1) {
                            _keys.push(this.fields[key]);
                        }
                    });
                    el.complete = Object.keys(_keys).every((key) => _keys[key].valid);
                }
            });
        },
        checkIfDataComplete (object) {
            let isValid = true;
            Object.keys(object).forEach((key) => {
                if (object[key] === null || object[key] === '') {
                    isValid = false;
                }
            });
            return isValid;
        },
        indexNum (index) {
            return index + 1 + '.';
        },
        relations (index) {
            if (index === 0) {
                return this.roles.filter((el) => {
                    return el.description === 'Pan' || el.description === 'Pani';
                });
            }
            return this.roles.filter((el) => {
                return el.description !== 'Pan' && el.description !== 'Pani';
            });
        }
    }
};
</script>

<style scoped></style>
